var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96094 6.57491H20.9609M10.9609 17.1631V10.8102M14.9609 17.1631V10.8102M16.9609 21.3984H8.96094C7.85637 21.3984 6.96094 20.4503 6.96094 19.2808V7.63373C6.96094 7.04896 7.40865 6.57491 7.96094 6.57491H17.9609C18.5132 6.57491 18.9609 7.04896 18.9609 7.63373V19.2808C18.9609 20.4503 18.0655 21.3984 16.9609 21.3984ZM10.9609 6.57491H14.9609C15.5132 6.57491 15.9609 6.10086 15.9609 5.51608V4.45726C15.9609 3.87249 15.5132 3.39844 14.9609 3.39844H10.9609C10.4087 3.39844 9.96094 3.87249 9.96094 4.45726V5.51608C9.96094 6.10086 10.4087 6.57491 10.9609 6.57491Z",
    stroke: "#F31825",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDeleteIcon);
export default __webpack_public_path__ + "static/media/TrashDeleteIcon.e6fb906a28f91e13ddfebd9ccbe9a87c.svg";
export { ForwardRef as ReactComponent };